export enum EventOrderbyEnum {
	Name = 1,
	Id = 2,
	Client = 3,
	Division = 4,
	ProductType = 5,
  DateOfCreation = 6
}
